import {Model} from '@/models'

export class Feed extends Model {
  static schemaName = 'feeds'
}